const tokenLifeTimeLimit = 30 * 60 * 1000;
const checkValidAuthTokenIntervalPeriod_ms = 30000;
const LENDERBLOCKADMINWHITELIST = [
    'mlewis',
    'chamkay',
    'apptester1'
]
export { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms, LENDERBLOCKADMINWHITELIST };